export default __webpack_public_path__ + "static/media/cookies.d71c0896.svg";